import { render, staticRenderFns } from "./Recap.vue?vue&type=template&id=0bb9ec72&"
import script from "./Recap.vue?vue&type=script&lang=js&"
export * from "./Recap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports